<template>
  <b-card title="Filtros">
    <div class="row">
      <div class="col-4">
          <PeriodFilter @changePeriod="onPeriodChange" :customWidth="'w-28'"/>
      </div>
      <div class="col-4">
        <vs-input
          class="w-100"
          label="Rut"
          placeholder="Escriba un rut para buscar"
          v-model.trim="client"
          @keyup.native="checkFilter"
        />
      </div>
      <div class="col-4">
        <vs-select
          autocomplete
          class="w-100"
          label="Razón social"
          placeholder="Escriba la razón social"
          v-model="businessName"
          @change="setFilter('razonSocial', businessName)"
        >
          <vs-select-item value="*" text="Todo" />
          <vs-select-item
            autocomplete
            :key="item.iut"
            :value="`iut:${item.iut}`"
            :text="item.razonSocial"
            v-for="item in transaccionality"
          />
        </vs-select>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import PeriodFilter from '@/febos/global/operations/components/transactionality/PeriodFilter';

export default {
  name: 'Filters',
  components: { PeriodFilter },
  data() {
    return {
      client: '',
      businessName: '',
      filteredData: []
    };
  },
  computed: {
    ...mapGetters('Operations', ['transaccionality']),
    ...mapGetters('Empresas', [
      'companies',
      'company'
    ])
  },
  methods: {
    ...mapActions('Operations', ['getTransaccionality']),
    setFilter(type, filter) {
      this.$emit(`${type}`, {
        filterName: `${type}`,
        filter
      });
    },
    checkFilter() {
      if (this.client === '') this.setFilter('iut', '');
      else this.setFilter('iut', `iut:${this.client}`);
    },
    async onPeriodChange(selectedPeriod) {
      const data = await this.getTransaccionality({
        params: {
          periodo: selectedPeriod.filter,
          paginaActual: this.page,
          elementosPorPagina: 10,
        }
      });
      this.filteredData = data;
    }
  }
};
</script>
